export const COURSE_ASSIGN_MENU_KEY = "course-assign";
export const COURSE_ASSIGN_ASSIGN_MENU_KEY = "course-assign-list";
export const SPECIAL_INITIATIVE_COURSES_MENU_KEY = "special-initiative-courses";
